"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnFilterModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const ArrayExtensions_1 = tslib_1.__importDefault(require("../Utilities/Extensions/ArrayExtensions"));
const LayoutRedux = tslib_1.__importStar(require("../Redux/ActionsReducers/LayoutRedux"));
const SystemRedux = tslib_1.__importStar(require("../Redux/ActionsReducers/SystemRedux"));
const FilterStatusBarSubPanelPopover_1 = require("../View/Filter/FilterStatusBarSubPanelPopover");
const getLayoutFilterViewItems_1 = require("./Utilities/Layout/getLayoutFilterViewItems");
class ColumnFilterModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.ColumnFilterModuleId, ModuleConstants.ColumnFilterFriendlyName, 'filter', 'FilterPopup', 'Advanced filtering capability allows users to see precisely the data they want', api);
    }
    setModuleEntitlement() {
        if (!this.api.optionsApi.getColumnFilterOptions().useAdaptableColumnFiltering) {
            this.AccessLevel = 'Hidden';
        }
        else {
            this.AccessLevel = this.api.internalApi
                .getEntitlementService()
                .getEntitlementAccessLevelForModule(this.moduleInfo.ModuleName);
        }
    }
    getModuleAdaptableObjects() {
        return this.api.columnFilterApi.getColumnFilters();
    }
    getExplicitlyReferencedColumnIds(columnFilter) {
        return [columnFilter.ColumnId];
    }
    hasNamedQueryReferences() {
        return false;
    }
    updateOldConfig() {
        // Note: have updated Dashboard and Status bar but NOT Tool Panels
        // Update Module Buttons
        let updateModuleButtons = false;
        let moduleButtons = this.api.dashboardApi.getModuleButtons();
        if (!moduleButtons.includes('ColumnFilter')) {
            moduleButtons = moduleButtons.map((moduleButton) => {
                if (moduleButton == 'Filter') {
                    updateModuleButtons = true;
                    return 'ColumnFilter';
                }
                return moduleButton;
            });
        }
        if (updateModuleButtons) {
            this.api.dashboardApi.setModuleButtons(moduleButtons);
        }
        // Update Toolbars
        let updateTabs = false;
        const tabs = this.api.dashboardApi.getTabs().map((tab) => {
            if (tab.Toolbars.includes('Filter') && !tab.Toolbars.includes('ColumnFilter')) {
                updateTabs = true;
                return Object.assign(Object.assign({}, tab), { 
                    // replace with 'GridFilter'
                    Toolbars: tab.Toolbars.map((t) => (t == 'Filter' ? 'ColumnFilter' : t)) });
            }
            return tab;
        });
        if (updateTabs) {
            this.api.dashboardApi.setTabs(tabs);
        }
        // - move pinned toolbars
        let updatePinnedToolbars = false;
        let pinnedToolbars = this.api.dashboardApi.getPinnedToolbars();
        if (pinnedToolbars && !(pinnedToolbars === null || pinnedToolbars === void 0 ? void 0 : pinnedToolbars.includes('ColumnFilter'))) {
            pinnedToolbars = pinnedToolbars.map((pinnedToolbar) => {
                if (pinnedToolbar == 'Filter') {
                    updatePinnedToolbars = true;
                    return 'ColumnFilter';
                }
                return pinnedToolbar;
            });
        }
        if (updatePinnedToolbars) {
            this.api.dashboardApi.setPinnedToolbars(pinnedToolbars);
        }
        // Update Status Bar
        let updateStatusBars = false;
        const statusBars = this.api.statusBarApi
            .getAdaptableStatusBars()
            .map((panel) => {
            return Object.assign(Object.assign({}, panel), { StatusBarPanels: panel.StatusBarPanels.map((panel) => {
                    if (panel === 'Filter') {
                        updateStatusBars = true;
                        return 'ColumnFilter';
                    }
                    return panel;
                }) });
        });
        if (updateStatusBars) {
            this.api.statusBarApi.setStatusBarPanels(statusBars);
        }
    }
    handleAdaptableReady() {
        if (this.api.optionsApi.getColumnFilterOptions().quickFilterOptions.showQuickFilter == false) {
            this.api.columnFilterApi.hideQuickFilterBar();
        }
        const columnFilters = this.api.columnFilterApi.getColumnFilters();
        columnFilters.forEach((cf) => {
            if (!this.api.columnApi.isColumnInGrid(cf.ColumnId)) {
                this.api.logError('Column Filter contains missing column: ' + cf.ColumnId);
            }
        });
    }
    addContextMenuItems(menuContext) {
        if (!menuContext.isRowGroupColumn && this.isModuleAvailable()) {
            if (menuContext.adaptableColumn &&
                menuContext.adaptableColumn.filterable &&
                menuContext.isSingleSelectedColumn &&
                menuContext.gridCell != null &&
                this.api.optionsApi.getColumnFilterOptions().useAdaptableColumnFiltering) {
                const existingColumnFilter = this.getExistingColumnFilter(menuContext.adaptableColumn);
                if (!existingColumnFilter) {
                    let isMultiple = menuContext.selectedCellInfo.gridCells.length > 1;
                    let clickFunction = isMultiple
                        ? () => {
                            this.api.columnFilterApi.internalApi.createValuesColumnFilterForCells(menuContext.selectedCellInfo.gridCells);
                        }
                        : () => {
                            this.api.columnFilterApi.internalApi.createEqualityColumnFilterForCell(menuContext.selectedCellInfo.gridCells[0]);
                        };
                    return [
                        this.createColumnMenuItemClickFunction(isMultiple ? 'Filter on Cell Values' : 'Filter on Cell Value', this.moduleInfo.Glyph, clickFunction),
                    ];
                }
                else {
                    let filterSubMenuItems = [];
                    filterSubMenuItems.push(this.createColumnMenuItemReduxAction('Clear Filter', 'close', LayoutRedux.LayoutColumnFilterClear(existingColumnFilter)));
                    filterSubMenuItems.push(this.createColumnMenuItemClickFunction(existingColumnFilter.IsSuspended ? 'Unsuspend Filter' : 'Suspend Filter', existingColumnFilter.IsSuspended ? 'resume' : 'pause', existingColumnFilter.IsSuspended
                        ? () => {
                            this.api.columnFilterApi.unSuspendColumnFilter(existingColumnFilter);
                        }
                        : () => {
                            this.api.columnFilterApi.suspendColumnFilter(existingColumnFilter);
                        }));
                    return [
                        {
                            label: this.moduleInfo.FriendlyName,
                            isVisible: true,
                            module: this.moduleInfo.ModuleName,
                            icon: {
                                name: this.moduleInfo.Glyph,
                            },
                            subItems: filterSubMenuItems,
                        },
                    ];
                }
            }
        }
    }
    addColumnMenuItems(column) {
        let filterSubMenuItems = [];
        if (column &&
            column.filterable &&
            this.api.optionsApi.getColumnFilterOptions().useAdaptableColumnFiltering) {
            if (this.api.gridApi.isQuickFilterAvailable()) {
                const isFilterVisible = this.api.columnFilterApi.isQuickFilterVisible();
                if (this.isModuleEditable() &&
                    this.api.optionsApi.getColumnFilterOptions().useAdaptableColumnFiltering) {
                    filterSubMenuItems.push(this.createColumnMenuItemReduxAction(isFilterVisible ? 'Hide Filter Bar' : 'Show Filter Bar', isFilterVisible ? 'unchecked' : 'check', isFilterVisible
                        ? SystemRedux.SystemQuickFilterBarHide()
                        : SystemRedux.SystemQuickFilterBarShow()));
                }
            }
            const existingColumnFilter = this.getExistingColumnFilter(column);
            if (existingColumnFilter) {
                filterSubMenuItems.push(this.createColumnMenuItemReduxAction('Clear Filter', 'close', LayoutRedux.LayoutColumnFilterClear(existingColumnFilter)));
                filterSubMenuItems.push(this.createColumnMenuItemReduxAction(existingColumnFilter.IsSuspended ? 'Unsuspend Filter' : 'Suspend Filter', existingColumnFilter.IsSuspended ? 'resume' : 'pause', existingColumnFilter.IsSuspended
                    ? LayoutRedux.LayoutColumnFilterUnSuspend(existingColumnFilter)
                    : LayoutRedux.LayoutColumnFilterSuspend(existingColumnFilter)));
            }
            if (ArrayExtensions_1.default.IsNotNullOrEmpty(filterSubMenuItems)) {
                return [
                    {
                        label: this.moduleInfo.FriendlyName,
                        isVisible: true,
                        module: this.moduleInfo.ModuleName,
                        icon: {
                            name: this.moduleInfo.Glyph,
                        },
                        subItems: filterSubMenuItems,
                    },
                ];
            }
        }
    }
    getExistingColumnFilter(column) {
        return this.api.columnFilterApi.getColumnFilters().find((x) => x.ColumnId == column.columnId);
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.columnFilterApi.getColumnFilters(),
            AddAction: LayoutRedux.LayoutColumnFilterAdd,
            EditAction: LayoutRedux.LayoutColumnFilterEdit, //TODO need to change this to ColumnFilterSet
        };
    }
    toViewCompact(filter) {
        return {
            item: {
                values: [this.api.columnFilterApi.internalApi.columnFilterToString(filter)],
            },
            abObject: filter,
        };
    }
    toView(filter) {
        return {
            items: [
                {
                    name: 'Column',
                    values: [this.api.columnApi.getFriendlyNameForColumnId(filter.ColumnId)],
                },
                {
                    name: 'Filter',
                    values: [(0, getLayoutFilterViewItems_1.getFilterPreview)(filter, this.api)],
                },
            ],
            abObject: filter,
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects().map((filter) => this.toView(filter));
    }
    getViewProperties() {
        const api = this.api;
        return {
            getSuspendAction: (columnFilter) => LayoutRedux.LayoutColumnFilterSuspend(columnFilter),
            getUnSuspendAction: (columnFilter) => LayoutRedux.LayoutColumnFilterUnSuspend(columnFilter),
            getCompactSuspendAction: (columnFilter) => LayoutRedux.LayoutColumnFilterSuspend(columnFilter),
            getCompactUnSuspendAction: (columnFilter) => LayoutRedux.LayoutColumnFilterUnSuspend(columnFilter),
            getSuspendAllAction: () => LayoutRedux.LayoutColumnFilterSuspendAll(),
            getUnSuspendAllAction: () => LayoutRedux.LayoutColumnFilterUnSuspendAll(),
            getDeleteAction: LayoutRedux.LayoutColumnFilterClear,
            getCompactDeleteAction: LayoutRedux.LayoutColumnFilterClear,
            getDeleteAllAction: LayoutRedux.LayoutColumnFilterClearAll,
            emptyView: `
        There are currently no Column Filters applied. \n

        Create Column Filters by using the Filter Bar, the Filter Form (in the Column Header Menu) or by editing a Layout.
      `,
            getStatusBarPanelProps() {
                let text;
                const filters = api.columnFilterApi.getColumnFilters();
                if (filters.length === 0) {
                    text = '0 Filters';
                }
                else if (filters.length === 1) {
                    text = '1 Filter';
                }
                else {
                    text = filters.length + ' Filters';
                }
                const popover = filters.length ? FilterStatusBarSubPanelPopover_1.FilterStatusBarSubPanelPopover : null;
                return {
                    content: text,
                    popover,
                    popoverMinWidth: 320,
                };
            },
        };
    }
}
exports.ColumnFilterModule = ColumnFilterModule;
